import {isNil, isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

export const getOffsetPaymentDefaultAmount = (
  paymentAmount: string | Nullish,
  offsetAmount: string | undefined,
  orderPrice?: string | Nullish
): number => {
  const parsedPaymentAmount = parseFloat(paymentAmount ?? '0');
  const isBlank = isNil(paymentAmount) || paymentAmount === '' || parsedPaymentAmount === 0;

  if (isNotNil(offsetAmount) && isBlank) {
    const offsetParsed = parseFloat(offsetAmount);
    const isParsedOffsetValid = Number.isFinite(offsetParsed);
    if (!isParsedOffsetValid) {
      return 0;
    }
    if (isNotNil(orderPrice)) {
      const orderParsed = parseFloat(orderPrice);
      const isParsedOrderValid = Number.isFinite(orderParsed);
      if (isParsedOrderValid && offsetParsed > orderParsed) {
        return orderParsed;
      }
    }
    return offsetParsed;
  }

  return isNaN(parsedPaymentAmount) ? 0 : parsedPaymentAmount;
};
